export default __webpack_public_path__ + "static/product-unit-20-family-b37640b0d2ae529e906d83b6c7e56a51.png";